  import { createStore } from 'stimulus-store';

  const searchDocumentsStore = createStore({
    name: 'searchDocumentsStore',
    type: Array,
    initialValue: [],
  });

  export default searchDocumentsStore;
